<div class="loadable" [class.loading]="loadingLevel === 'global'">
    <ui-banner *ngIf="isErrored" variant="danger">
        {{ 'settings.sso.loadingFailedErrorMessage' | translate }}
    </ui-banner>

    <mat-accordion>
        <mat-expansion-panel disabled [hideToggle]="true" [expanded]="isExpanded" class="borderless">
            <mat-expansion-panel-header class="w-100 hide-toggle"
                ><div class="setting" [class.disabled]="isErrored">
                    <div class="setting-description">
                        <h3>{{ 'settings.signIn.sso.title' | translate }}</h3>
                        <div>{{ 'settings.signIn.sso.description' | translate }}</div>
                    </div>
                    <mat-slide-toggle
                        color="primary"
                        (click)="$event.stopPropagation()"
                        (change)="isExpanded = !isExpanded"
                        [checked]="isExpanded"
                        [disabled]="isErrored"
                    >
                    </mat-slide-toggle></div
            ></mat-expansion-panel-header>
            <h6 aria-level="3" class="sso-subtitle">{{ 'settings.signIn.sso.subtitle' | translate }}</h6>
            <div class="sso-toggles-container">
                <!-- TODO: hideToggle to be set to false or removed after Mobile is caught up. Don't forget to update tests in sso.spec.ts-->
                <app-image-toggle
                    *ngFor="let provider of SSO_PROVIDER_CONFIG | keyvalue"
                    [hideToggle]="true"
                    label="{{ provider.value.translationKey + '.label' | translate }}"
                    [isLoading]="loadingLevel === provider.key"
                    [(ngModel)]="activeSSOProviders[provider.key]"
                    (ngModelChange)="handleProviderToggle([provider.key], $event)"
                    src="{{ provider.value.logoURL }}"
                    ><a
                        class="text-small"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="{{ provider.value.translationKey + '.helpURL' | translate }}"
                        >{{ 'settings.signIn.sso.learnMore' | translate }}</a
                    ></app-image-toggle
                >
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>
